import {Column, Row} from "tabloom"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, View} from "shared/base"
import calculateAverageMood from "./calculate-average-mood"
import ClassStepRow from "./class-step-row"
import {digg} from "diggerize"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import mergeStyles from "@kaspernj/api-maker/build/merge-styles"
import {Pressable} from "react-native"
import React from "react"
import {styles} from "../class-status-route"

export default memo(shapeComponent(class RoutesUserClassStatusSchoolRow extends ShapeComponent {
  static propTypes = propTypesExact({
    classStatusRoute: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    lastRow: PropTypes.bool.isRequired,
    schoolData: PropTypes.object.isRequired
  })

  setup() {
    this.expandIdentifier = React.useMemo(() => `school-${this.p.schoolData.schoolId}`, [])
    this.useStates({
      expanded: () => {
        const savedExpanded = this.p.classStatusRoute.s.expanded[this.tt.expandIdentifier]

        if (savedExpanded === true || savedExpanded === false) {
          return savedExpanded
        }

        return true
      }
    })
  }

  render() {
    const {lastRow, schoolData} = this.p
    const {expanded} = this.s
    const school = schoolData.school
    const classStepsDatas = Object.values(schoolData.classSteps)
    const latestMoods = digg(schoolData, "latestMoods")
    const moods = digg(schoolData, "moods")

    return (
      <>
        <Row
          dataSet={this.cache("rowDataSet", {
            expanded,
            schoolId: school.id()
          }, [expanded, school.id()])}
          style={this.cache("rowStyle", {
            backgroundColor: "#e5dfff",
            borderColor: "#e5dfff",
            borderBottomWidth: lastRow ? 1 : 0,
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderStyle: "solid",
            borderBottomLeftRadius: lastRow && !expanded ? 24 : 0,
            borderBottomRightRadius: lastRow && !expanded ? 24 : 0
          }, [expanded, lastRow])}
          testID="routes/user/class-status/school-row"
        >
          <Column style={this.nameColumnStyle ||= {flexDirection: "row", alignItems: "center", paddingLeft: 4}}>
            <View
              style={this.cache("nameContainerViewStyle", {
                alignItems: "center",
                flexDirection: "row",
                width: "100%",
                height: "100%",
                padding: 18,
                backgroundColor: "#f2efff",
                borderBottomLeftRadius: lastRow && !expanded ? 24 : 0
              }, [expanded, lastRow])}
            >
              <Pressable
                onPress={this.tt.onExpandPress}
                style={this.nameIconPressableStyle ||= mergeStyles([styles.columnText, {marginRight: 4}])}
                testID="expand-button"
              >
                <Icon name={expanded ? "chevron-up" : "chevron-down"} />
              </Pressable>
              <Text style={this.nameTextStyle ||= mergeStyles([styles.columnText, {fontWeight: "bold"}])}>
                {school.name()}
              </Text>
            </View>
          </Column>
          <Column style={this.nicknameColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}} testID="nickname-column" />
          <Column style={this.teachersColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}}>
            <Text style={styles.columnText}>{schoolData && Object.keys(schoolData.teachers).length}</Text>
          </Column>
          <Column style={this.topPositiveScoreFactorColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}}>
            <Text style={styles.columnText}>{digg(schoolData, "topPositiveScoreFactor")?.name()}</Text>
          </Column>
          <Column style={this.topNegativeScoreFactorColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}}>
            <Text style={styles.columnText}>{digg(schoolData, "topNegativeScoreFactor")?.name()}</Text>
          </Column>
          <Column style={this.moodsColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}}>
            <Text style={styles.columnText}>{moods && calculateAverageMood(moods)}</Text>
          </Column>
          <Column style={this.latestMoodsColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}}>
            <Text style={styles.columnText}>{latestMoods?.length > 0 && calculateAverageMood(latestMoods)}</Text>
          </Column>
          <Column style={this.checkInsCountColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}} testID="check-ins-column">
            <Text style={styles.columnText}>{digg(schoolData, "checkInsCount")}</Text>
          </Column>
          <Column style={this.brainBreaksCountColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}} testID="brain-breaks-column">
            <Text style={styles.columnText}>{digg(schoolData, "brainBreaksCount")}</Text>
          </Column>
          <Column style={this.challengesCountColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}} testID="challenges-column">
            <Text style={styles.columnText}>{digg(schoolData, "challengesCount")}</Text>
          </Column>
          <Column style={this.unicornEffectsCountColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}}>
            <Text style={styles.columnText}>{digg(schoolData, "unicornEffectsCount")}</Text>
          </Column>
          <Column style={this.activeCoursesColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}}>
            <Text style={styles.columnText}>{digg(schoolData, "activeCourses")}</Text>
          </Column>
          <Column style={this.actionsColumnStyle ||= {padding: 18, backgroundColor: "#f2efff"}} />
        </Row>
        {expanded && this.orderedClassSteps().map((classStepData, classStepIndex) =>
          <ClassStepRow
            classStatusRoute={this.p.classStatusRoute}
            classStepData={classStepData}
            key={classStepData.classStep?.id() || "no-class-step"}
            lastRow={lastRow && (classStepIndex + 1) == classStepsDatas.length}
            school={school}
          />
        )}
      </>
    )
  }

  onExpandPress = () => {
    const schoolId = digg(this.p.schoolData, "schoolId")

    this.setState({expanded: !this.s.expanded})
    this.p.classStatusRoute.updateExpanded({expanded: this.s.expanded, identifier: this.tt.expandIdentifier, modelClass: "School", modelId: schoolId})
  }

  orderedClassSteps = () => Object.values(this.p.schoolData.classSteps).sort((classStepData1, classStepData2) =>
    classStepData1.classStep?.primarySchoolStep() - classStepData2.classStep?.primarySchoolStep()
  )
}))
